import { ButtonProps } from 'antd';
import { createContext, ReactNode } from 'react';
import { COLORS } from 'shared/const/theme';

export const Types = {
  info: COLORS.INFO,
  error: COLORS.ERROR,
  warning: COLORS.WARNING,
  success: COLORS.SUCCESS
} as const;

export type ModalTypes = keyof typeof Types;

export type ModalOptions = {
  title: string;
  content?: string;
  type?: ModalTypes;
  icon?: ReactNode;
  action?: boolean;
  actionButton?: ButtonProps;
}

interface ModalContextType {
  showResult: (options: ModalOptions) => void | null;
}

const ModalContext = createContext<ModalContextType>({
  showResult: (options) => null
})

export default ModalContext;